import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  sortFilters: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    padding: '8px 16px',
    borderRadius: 8,
    marginBottom: 8,
    '& span': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover': {
        fontWeight: 600
      }
    }
  },
  active: {
    fontWeight: 600
  },
  name: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center'
  },
  created: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    width: 109,
    justifyContent: 'flex-end'
  },
  notificationsList: {
    overflowY: 'auto',
    height: 'calc(100% - 80px)'
  },
  revert: {
    transform: 'rotate(180deg)'
  },
  markAsReadSelected: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fill: theme.palette.text.secondary
    },
    '& .Mui-disabled svg': {
      fill: theme.palette.text.disabled
    }
  }
}))

export default useStyles
